export default __webpack_public_path__ + "static/media/law.687109d7.svg";